<template>
  <div>
    <div>
      <!-- <Tag
        v-for="item in count"
        :key="item"
        :name="item"
        closable
        @on-close="handleClose2"
      >标签{{ item + 1 }}</Tag>
      <Input search enter-button placeholder="Enter something..."/>
      <Button icon="ios-add" type="dashed" size="small" @click="handleAdd">添加条件</Button>-->
      <Button type="primary" icon="ios-search" @click="searchByConditionsView">按条件查询</Button>
	      <Button type="primary" icon="md-cloud-upload"
              onclick="$('#upload_file_address').click();" style="margin-left: 20px;">导入Excel</Button>
        <Button type="primary" icon="md-cloud-upload" @click="exportTable()" style="margin-left: 20px;">导出Excel</Button>
        <Button type="primary" style="margin-left: 20px;" @click="downProfile">下载模版</Button>
        <Button type="primary" v-if="isAdmin" style="margin-left: 20px;" @click="showSetModal = true">设置阈值</Button>
	  <Upload
		ref="upload"
		name="upfile"
		:action="importUrl"
		:on-success="handleImportAddressTemplate" 
		:before-upload="beforeImportAddressTemplate"
		:format="['xlsx','xls']"
		:show-upload-list="false"
		>
		<input id="upload_file_address" style="display: none;" />
	  </Upload>
      <!-- <Button type="primary" style="margin-left: 5px" @click="showDown = true">数据下发</Button> -->
    </div>

    <div>
      <Modal title="Title" v-model="showBindCheck" :mask-closable="false" width="720">
        <p slot="header" style="color:#0066FF;text-align:center">
          <span>绑定状态</span>
        </p>
        <div style="text-align:center">
          <Table size="large" border stripe :loading="loading" :columns="columns2" :data="bindArray">
			<template slot-scope="{ row, index }" slot="deparams">
				<Button type="primary" @click="debind(row)">解绑</Button>
			</template>
		</Table>
        </div>
        <div slot="footer">
          
        </div>
      </Modal>
    </div>

    <div>
      <Modal title="Title" v-model="showSetModal" :mask-closable="false" width="360">
        <p slot="header" style="color:#0066FF;text-align:center">
          <span>设置阈值</span>
        </p>
        <Row style="padding-bottom: 10px;margin-top: 10px;">
          <Col span="12" style="padding-right: 10px;">
            超期失联（天）：
          </Col>
          <Col span="4" style="padding-right: 10px;">
            <InputNumber v-model="overdue" placeholder="请输入超期失联阈值（天）" style="width: 150px" />
          </Col>
        </Row>
        <Row style="padding-bottom: 10px;margin-top: 10px;">
          <Col span="12" style="padding-right: 10px;">
            气表损坏或偷盗气（天）：
          </Col>
          <Col span="4" style="padding-right: 10px;">
            <InputNumber v-model="steal" placeholder="请输入偷盗气阈值（天）" style="width: 150px" />
          </Col>
        </Row>
        <Row style="padding-bottom: 10px;margin-top: 10px;">
          <Col span="12" style="padding-right: 10px;">
           ΔP调整（天）：
          </Col>
          <Col span="4" style="padding-right: 10px;">
            <InputNumber v-model="poverdue" placeholder="请输入ΔP调整阈值（天）" style="width: 150px" />
          </Col>
        </Row>
        <Row style="padding-bottom: 10px;margin-top: 10px;">
          <Col span="12" style="padding-right: 10px;">
           差压调整（次）：
          </Col>
          <Col span="4" style="padding-right: 10px;">
            <InputNumber v-model="collection" placeholder="请输入差压调整阈值（次）" style="width: 150px" />
          </Col>
        </Row>
        <div slot="footer">
          <Button icon="md-search" type="info" size="large" long @click="updateConfig">保存</Button>
        </div>
      </Modal>
    </div>

    <!-- 模态框 -->
    <div>
      <Modal title="Title" v-model="modal8" :mask-closable="false" width="380">
        <p slot="header" style="color:#0066FF;text-align:center">
          <Icon type="md-create" />
          <span>按条件检索</span>
        </p>
        <div style="text-align:center">
          <CheckboxGroup v-model="selectedCondition" class="check_grop">
            <div>
              <Checkbox label="saveId">
                <span>设备编号</span>
              </Checkbox>
              <Input v-model="saveIdModel" placeholder="请输入设备编号" style="width: 150px" />
            </div>
            <!-- <div>
              <Checkbox label="deviceId">
                <span>设备MAC</span>
              </Checkbox>
              <Input v-model="deviceIdModel" placeholder="请输入设备MAC" style="width: 150px" />
            </div> -->
            <!-- <div>
              <Checkbox label="mainType">
                <span>主命令字&nbsp;&nbsp;&nbsp;</span>
              </Checkbox>
              <Select v-model="mainTypeModel" style="width:150px" placeholder="请选择命令字">
                <Option v-for="(value, key) in valveProfile" :value="key" :key="key">{{key}}</Option>
              </Select>
            </div>-->
            <!-- <div>
              <Checkbox label="subType">
                <span>报警类型&nbsp;&nbsp;&nbsp;</span>
              </Checkbox>
              <Select v-model="subTypeModel" style="width:150px" placeholder="请选择命令字">
                <Option
                  v-for="(value, key) in valveProfile['errorTrig']"
                  :value="key"
                  :key="key"
                >{{value.cn}}</Option>
              </Select>
            </div>
            <div>
              <Checkbox label="timeStamp">
                <span>时间区间</span>
              </Checkbox>
              <Tooltip
                transfer
                placement="top"
                :disabled="timeStampModel == undefined || timeStampModel[0] == ''"
              >
                <div slot="content">
                  <span>{{dateFtt('yyyy-MM-dd hh:mm:ss',timeStampModel[0])}}</span>
                  <br />
                  <span style="margin-left:50%">~</span>
                  <br />
                  <span>{{dateFtt('yyyy-MM-dd hh:mm:ss',timeStampModel[1])}}</span>
                </div>
                <DatePicker
                  v-model="timeStampModel"
                  type="daterange"
                  split-panels
                  placeholder="请选择时间区间"
                  style="width: 150px"
                ></DatePicker>
              </Tooltip>
            </div> -->
          </CheckboxGroup>
        </div>
        <div slot="footer">
          <Button icon="md-search" type="info" size="large" long @click="searchByCondition">检索</Button>
        </div>
      </Modal>
    </div>
    <br />
    <Table ref="table" size="large" border stripe :loading="loading" :columns="columns1" :data="data1">
      <template slot-scope="{ row, index }" slot="deparams">
        <!-- <Button type="primary" @click="clickBindCheck(row)">查看绑定状态</Button> -->
        <Button style="margin-left:5px" type="primary" @click="clickDeleteValve(row)">删除</Button>
        <Button style="margin-left:15px" type="primary" @click="debind(row)">解绑</Button>
      </template>
    </Table>
    <br />
    <Page
      :current="pageNo"
      :total="pageTotal"
      :page-size="pageSize"
      :page-size-opts="[5, 10, 20, 30, 40]"
      show-sizer
      show-total
      @on-change="changePage"
      @on-page-size-change="changePageSize"
    />
  </div>
</template>

<script>
import { constants } from "crypto";
export default {
  name: "valve_manage",
  mounted() {
    // this.tableHeight =
    //   window.innerHeight - this.$refs.table.$el.offsetTop - 160;
    if (localStorage.getItem("isAdmin") != "true") {
      this.gId = localStorage.getItem("personnelGroverningBodyId");
      this.importUrl = this.importUrl + this.gId
      console.log(this.requestBody);
    }else{
      this.gId = "";
      this.isAdmin = true;
    }
    this.request();
  },
  created() {
    this.getValveProfile();
    this.getValvesNo();
    // this.getValveDownProfile();
  },
  methods: {
    downProfile(){
      window.location.href = "http://www.cnzhuocheng.cn/%e5%af%bc%e5%85%a5%e6%a8%a1%e7%89%88.xls" 
    },
	beforeImportAddressTemplate(file){
		
	},
	handleImportAddressTemplate(response, file, fileList) {
      console.log(response);
      console.log(file);
      console.log(fileList);
      // this.handelResponse(response);
      this.$Notice.info({
            title: "提示",
            desc: response.msg
          });
          this.request();
    },
	clickBindCheck(item){
		// console.log(item.valveBaseId);
		this.getBindInfo(item.valveBaseId);
		this.showBindCheck = true;

  },
  exportTable(){
      this.$refs.table.exportCsv({
          filename: '设备信息',
      });
    },
    reloadDown(type) {
      if (this.selectedDownValve == "" || this.selectedDownValve == undefined) {
        this.$Notice.error({
          title: "异常",
          desc: "请选择载入设备号"
        });
        return;
      }
      var that = this;
      this.pageNo = 1;
      $.ajax({
        url: "/api/valve/getLastDownValve",
        contentType: "application/json",
        type: "post",
        data: JSON.stringify({
          messageMac: that.selectedDownValve,
          messageMaintype: "paramSet",
          messageSubtype: type
        }),
        dataType: "json",
        success: function(data) {
          if (data.errorCode != 0) {
            that.$Notice.error({
              title: "异常",
              desc: data.errorInfo
            });
            return;
          }
          let body = data.body;
          if (body.length == 0) {
            that.reloadMessage[type] =
              "无历史下发" + type + "类型数据故无法载入";
          } else {
            let lastDown = body[0];
            console.log(lastDown);
            let timestamp = global.dateFtt(
              "yyyy-MM-dd hh:mm:ss",
              new Date(lastDown.messageReceivetimestamp)
            );
            let downContent = JSON.parse(lastDown.messageContent);
            console.log(downContent);
            Object.keys(downContent).forEach(function(key) {
              that.paramSet[type][key] = downContent[key];
            });
            that.reloadMessage[type] =
              "已载入" + timestamp + "下发的" + type + "数据";
            that.$forceUpdate();
          }
          that.$Notice.info({
            title: "提示",
            desc: that.reloadMessage[type]
          });
          that.loading = false;
        },
        error: function(textStatus) {
          that.loading = false;
          that.$Notice.error({
            title: "异常",
            desc: "接口请求异常"
          });
        }
      });
    },
    preStep() {
      this.currentDownStep = this.currentDownStep - 1;
    },
    nextStep(type) {
      var that = this;
      if (this.currentDownStep == 0) {
        if (this.selectValveArray.length == 0) {
          this.$Notice.info({
            title: "提示",
            desc: "请至少添加一个设备"
          });
        } else {
          this.currentDownStep = this.currentDownStep + 1;
          Object.keys(this.reloadMessage).forEach(function(key) {
            this.reloadMessage[key] = "";
          });
        }
      } else if (this.currentDownStep == 1) {
        this.$Modal.confirm({
          title: "操作确认",
          content: "确认进行下发操作？",
          onOk: () => {
            that.downMessage(type);
            that.currentDownStep = 0;
            that.showDown = false;
            Object.keys(that.valveProfile.paramSet).forEach(function(
              profileName
            ) {
              let profile = that.valveProfile.paramSet[profileName].params;
              let temp = {};
              Object.keys(profile).forEach(function(key) {
                temp[key] = profile[key].default;
              });
              that.paramSet[profileName] = temp;
              that.reloadMessage[profileName] = "";
            });
          },
          onCancel: () => {}
        });
      }
    },
    handleClose(item) {
      this.selectValveArray.pop(item);
    },
    dateFtt(fmt, date) {
      return global.dateFtt(fmt, new Date(date));
    },
    clickDeleteValve(row){
      var that = this;
      this.$Modal.confirm({
        title: '确认',
        content: '<p>是否确认删除</p>',
        onOk: () => {
          that.deleteValve(row);
        },
        onCancel: () => {
          // this.$Message.info('Clicked cancel');
        }
      });
    },
    request() {
      var that = this;
      // this.pageNo = 1;
      //   this.requestBody["messageMaintype"] = "upload";
      //   this.requestBody["messageSubtype"] = "valveOperation";
      this.getValveMessage();
      this.getConfigSteal();
      this.getConfigOverdue();
      this.getConfigPOverdue();
      this.getConfigCollection();
      // this.$axios({
      //   method: "post",
      //   url: "/api/selectInstructions",
      //   headers: { "Content-Type": "text/json" },
      //   data: JSON.stringify({ name: 1, pwd: 2 }),
      //   transformRequest: [
      //     function(data) {
      //       // console.log(JSON.stringify(data))
      //       // console.log(qs.stringify(data))
      //       // console.log(qs.stringify(JSON.stringify(data)))
      //       console.log(data);
      //       this.data1 = data;
      //     }
      //   ]
      // });
    },

    ok() {},
    cancel() {},
    del() {},
    // 修改页面容量
    changePageSize(pageSize) {
      this.pageSize = pageSize;
      this.request();
	},
	debind(row){
		// console.log(row.relationshipId);
		var that = this;
		this.$Modal.confirm({
			title: '确认',
			content: '<p>是否确认解绑</p>',
			onOk: () => {
				that.deBindUser(row);
			},
			onCancel: () => {
				// this.$Message.info('Clicked cancel');
			}
		});
		
		
	},
    // 修改
    getValvesNo() {
      var that = this;
      that.loading = true;
      $.ajax({
        url: "/api/valve/getValvesMac",
        contentType: "application/json",
        type: "get",
        dataType: "json",
        success: function(data) {
          that.valvesNo = data.body;
          console.log(that.valvesNo);
        },
        error: function(textStatus) {
          that.$Notice.error({
            title: "异常",
            desc: "接口请求异常"
          });
        },
        complete: function() {
          that.loading = false;
        }
      });
	},
	getBindInfo(id) {
	  var that = this;
	  var params = {};
	  params["valveBaseId"] = id;
      that.loading = true;
      $.ajax({
        url: "/api/mp/getValveBaseInfoWithUser",
        contentType: "application/json",
        type: "post",
		dataType: "json",
		data: JSON.stringify(params),
        success: function(data) {
		//   that.valvesNo = data.body;
			that.bindArray = data;
        //   console.log(data);
        },
        error: function(textStatus) {
          that.$Notice.error({
            title: "异常",
            desc: "接口请求异常"
          });
        },
        complete: function() {
          that.loading = false;
        }
      });
  },
  updateConfig(){
    var param1 = {};
    param1.configName = "overdue";
    param1.configContent = this.overdue;
    this.updateConfigR(param1);
    var param2 = {};
    param2.configName = "steal";
    param2.configContent = this.steal;
    this.updateConfigR(param2);
    var param3 = {};
    param3.configName = "poverdue";
    param3.configContent = this.poverdue;
    this.updateConfigR(param3);
    this.showSetModal = false;
    param4.configName = "collection";
    param4.configContent = this.collection;
    this.updateConfigR(param4);
    this.showSetModal = false;
    
  },
  updateConfigR(param){
    var that = this;
      that.loading = true;
      $.ajax({
        url: "/api/mp/updateConfig",
        contentType: "application/json",
        type: "post",
		dataType: "json",
		data: JSON.stringify(param),
        success: function(data) {
		//   that.valvesNo = data.body;
			// that.bindArray = data;
        //   console.log(data);
          // that.overdue = data.configContent*1;
        },
        error: function(textStatus) {
          that.$Notice.error({
            title: "异常",
            desc: "接口请求异常"
          });
        },
        complete: function() {
          that.loading = false;
        }
      });
  },
  getConfigPOverdue() {
	  var that = this;
	  var params = {};
	  params["configName"] = "poverdue";
      that.loading = true;
      $.ajax({
        url: "/api/mp/getConfig",
        contentType: "application/json",
        type: "post",
		dataType: "json",
		data: JSON.stringify(params),
        success: function(data) {
		//   that.valvesNo = data.body;
			// that.bindArray = data;
        //   console.log(data);
          that.poverdue = data.configContent*1;
        },
        error: function(textStatus) {
          that.$Notice.error({
            title: "异常",
            desc: "接口请求异常"
          });
        },
        complete: function() {
          that.loading = false;
        }
      });
  },
  getConfigCollection() {
	  var that = this;
	  var params = {};
	  params["configName"] = "collection";
      that.loading = true;
      $.ajax({
        url: "/api/mp/getConfig",
        contentType: "application/json",
        type: "post",
		dataType: "json",
		data: JSON.stringify(params),
        success: function(data) {
		//   that.valvesNo = data.body;
			// that.bindArray = data;
        //   console.log(data);
          that.collection = data.configContent*1;
        },
        error: function(textStatus) {
          that.$Notice.error({
            title: "异常",
            desc: "接口请求异常"
          });
        },
        complete: function() {
          that.loading = false;
        }
      });
  },
  
  getConfigOverdue() {
	  var that = this;
	  var params = {};
	  params["configName"] = "overdue";
      that.loading = true;
      $.ajax({
        url: "/api/mp/getConfig",
        contentType: "application/json",
        type: "post",
		dataType: "json",
		data: JSON.stringify(params),
        success: function(data) {
		//   that.valvesNo = data.body;
			// that.bindArray = data;
        //   console.log(data);
          that.overdue = data.configContent*1;
        },
        error: function(textStatus) {
          that.$Notice.error({
            title: "异常",
            desc: "接口请求异常"
          });
        },
        complete: function() {
          that.loading = false;
        }
      });
	},
  getConfigSteal() {
	  var that = this;
	  var params = {};
	  params["configName"] = "steal";
      that.loading = true;
      $.ajax({
        url: "/api/mp/getConfig",
        contentType: "application/json",
        type: "post",
		dataType: "json",
		data: JSON.stringify(params),
        success: function(data) {
		//   that.valvesNo = data.body;
			// that.bindArray = data;
        //   console.log(data);
          console.log(data.configContent);
          that.steal = data.configContent*1;
        },
        error: function(textStatus) {
          that.$Notice.error({
            title: "异常",
            desc: "接口请求异常"
          });
        },
        complete: function() {
          that.loading = false;
        }
      });
  },
  deleteValve(item) {
	  var that = this;
	  var params = {};
      that.loading = true;
      $.ajax({
        url: "/api/mp/deleteValve",
        contentType: "application/json",
        type: "post",
		dataType: "json",
		data: JSON.stringify(item),
        success: function(data) {
		//   that.valvesNo = data.body;
			that.bindArray = data;
        //   console.log(data);
        },
        error: function(textStatus) {
          that.$Notice.error({
            title: "异常",
            desc: "接口请求异常"
          });
        },
        complete: function() {
		  that.loading = false;
		  that.getValveMessage();
        }
      });
    },
	deBindUser(item) {
	  var that = this;
	  var params = {};
	  params["relationshipValveBaseid"] = item.valveBaseId;
      that.loading = true;
      $.ajax({
        url: "/api/mp/debindUserValue",
        contentType: "application/json",
        type: "post",
		dataType: "json",
		data: JSON.stringify(params),
        success: function(data) {
		//   that.valvesNo = data.body;
			that.bindArray = data;
        //   console.log(data);
        },
        error: function(textStatus) {
          that.$Notice.error({
            title: "异常",
            desc: "接口请求异常"
          });
        },
        complete: function() {
		  that.loading = false;
		  that.getBindInfo(item.valveBaseId);
        }
      });
    },
    // 修改
    changePage(index) {
      this.pageNo = index;

      this.loading = true;
      this.requestBody = {};
      for (var temp in this.selectedCondition) {
        // if (this.selectedCondition[temp] == "mainType") {
        //   if (this.mainTypeModel == "") {
        //     continue;
        //   }

        //   this.requestBody["messageMaintype"] = this.mainTypeModel;
        // }
        if (this.selectedCondition[temp] == "subType") {
          if (this.subTypeModel == "") {
            continue;
          }

          this.requestBody["messageSubtype"] = this.subTypeModel;
        }
        if (this.selectedCondition[temp] == "deviceId") {
          if (this.deviceIdModel == "") {
            continue;
          }

          this.requestBody["messageMac"] = this.deviceIdModel;
          // requestBody.set("deviceId", this.deviceIdModel);
        }
        if (this.selectedCondition[temp] == "saveId") {
          if (this.saveIdModel == "") {
            continue;
          }

          this.requestBody["valveBaseNumber"] = this.saveIdModel;
          // requestBody.set("saveId", this.saveIdModel);
        }
        if (this.selectedCondition[temp] == "timeStamp") {
          this.requestBody["startDate"] = this.timeStampModel[0];
          this.requestBody["endDate"] = this.timeStampModel[1];
        }
      }
      //   this.requestBody["messageMaintype"] = "upload";
      //   this.requestBody["messageSubtype"] = "valveOperation";

      this.getValveMessage();
    },
    // 按条件检索点击事件
    searchByCondition() {
      this.requestBody = {};
      for (var temp in this.selectedCondition) {
        // if (this.selectedCondition[temp] == "mainType") {
        //   if (this.mainTypeModel == "") {
        //     continue;
        //   }

        //   this.requestBody["messageMaintype"] = this.mainTypeModel;
        // }
        if (this.selectedCondition[temp] == "subType") {
          if (this.subTypeModel == "") {
            continue;
          }

          this.requestBody["messageSubtype"] = this.subTypeModel;
        }
        if (this.selectedCondition[temp] == "deviceId") {
          if (this.deviceIdModel == "") {
            continue;
          }

          this.requestBody["messageMac"] = this.deviceIdModel;
          // requestBody.set("deviceId", this.deviceIdModel);
        }
        if (this.selectedCondition[temp] == "saveId") {
          if (this.saveIdModel == "") {
            continue;
          }

          this.requestBody["valveBaseNumber"] = this.saveIdModel;
          // requestBody.set("saveId", this.saveIdModel);
        }
        if (this.selectedCondition[temp] == "timeStamp") {
          this.requestBody["startDate"] = this.timeStampModel[0];
          this.requestBody["endDate"] = this.timeStampModel[1];
        }
      }

    //   this.requestBody["messageMaintype"] = "upload";
    //   this.requestBody["messageSubtype"] = "valveOperation";

      // 调用接口查询

      this.loading = true;
      this.modal8 = false;
      this.pageNo = 1;
      this.getValveMessage();
    },
    getValveMessage() {
      if (localStorage.getItem("isAdmin") != "true") {
        this.requestBody["valveBaseRemark6"] = localStorage.getItem("personnelGroverningBodyId");
        console.log(this.requestBody);
      }
      var that = this;
      $.ajax({
        url:
          "/api/mp/getValveBaseInfo?page=" +
          that.pageNo +
          "&pageAmount=" +
          that.pageSize +
          "&paging=true",
        contentType: "application/json",
        type: "post",
        data: JSON.stringify(that.requestBody),
        dataType: "json",
        success: function(data) {
          //   if (data.errorCode != 0) {
          //     that.$Notice.error({
          //       title: "异常",
          //       desc: data.errorInfo
          //     });
          //     return;
          //   }
          that.$Notice.success({
            title: "提示",
            desc: "查询成功"
          });
          that.data1 = data.list;
          that.pageTotal = data.count;
          that.loading = false;
        },
        error: function(textStatus) {
          that.loading = false;
          that.$Notice.error({
            title: "异常",
            desc: "接口请求异常"
          });
        }
      });
    },
    selectValve() {
      if (this.selectValveArray.indexOf(this.selectedValve) > -1) {
        this.$Notice.info({
          title: "提示",
          desc: "请勿重复添加"
        });
      } else {
        this.selectValveArray.push(this.selectedValve);
      }
    },
    getValveDownProfile() {
      // 调用接口查询
      var that = this;
      that.loading = true;
      $.ajax({
        url: "/api/valve/getSafetyValveDownProfile",
        contentType: "application/json",
        type: "get",
        dataType: "json",
        success: function(data) {
          console.log(data);
          if (data.errorCode == 0) {
            that.valveDownProfile = data.body;
            Object.keys(that.valveDownProfile).forEach(function(profileName) {
              let profile = that.valveDownProfile[profileName];
              let temp = {};
              Object.keys(profile).forEach(function(key) {
                temp[key] = profile[key].default;
              });
              that.paramSet[profileName] = temp;
              that.reloadMessage[profileName] = "";
            });
            //   that.loading = false;
          } else {
            that.$Notice.error({
              title: "异常",
              desc: data.errorInfo
            });
          }

          that.loading = false;
        },
        error: function(textStatus) {
          that.loading = false;
          that.$Notice.error({
            title: "异常",
            desc: "接口请求异常"
          });
        }
      });
    },
    downMessage(type) {
      var that = this;
      let downParams = {};
      downParams[type] = {};
      Object.keys(that.valveProfile.paramSet[type].params).forEach(function(
        key
      ) {
        downParams[type][key] =
          that.valveProfile.paramSet[type].params[key].default + "";
        if (
          that.paramSet[type][key] != undefined &&
          that.paramSet[type][key] != ""
        ) {
          downParams[type][key] = that.paramSet[type][key] + "";
        }
      });

      $.ajax({
        url: "/api/valve/downValveMessage",
        contentType: "application/json",
        type: "post",
        dataType: "json",
        data: JSON.stringify({
          messageNoArray: that.selectValveArray,
          messageContent: JSON.stringify(downParams[type]),
          messageMaintype: "paramSet",
          messageSubtype: type,
          messageState: "0"
        }),
        success: function(data) {
          console.log(data);
          if (data.errorCode != 0) {
            that.$Notice.warning({
              title: "提示",
              desc: data.errorInfo
            });
            return;
          }

          that.$Notice.success({
            title: "提示",
            desc: "下发成功等待设备获取"
          });
        },
        error: function(textStatus) {
          that.$Notice.error({
            title: "异常",
            desc: "接口请求异常"
          });
        },
        complete: function() {
          that.loading = false;
          that.request();
        }
      });
    },
    getValveProfile() {
      // 调用接口查询
      var that = this;
      that.loading = true;
      $.ajax({
        url: "/api/mp/getValveProfile?date=" + new Date().getTime(),
        contentType: "application/json",
        type: "get",
        dataType: "json",
        success: function(data) {
          that.valveProfile = data;
          Object.keys(that.valveProfile.paramSet).forEach(function(
            profileName
          ) {
            let profile = that.valveProfile.paramSet[profileName].params;
            let temp = {};
            Object.keys(profile).forEach(function(key) {
              temp[key] = profile[key].default;
            });
            that.paramSet[profileName] = temp;
            that.reloadMessage[profileName] = "";
          });
          that.loading = false;
        },
        error: function(textStatus) {
          that.loading = false;
          that.$Notice.error({
            title: "异常",
            desc: "接口请求异常"
          });
        }
      });
    },
    // 显示条件检索页面
    searchByConditionsView() {
      this.modal8 = true;
    },
    handleClose2(event, name) {
      const index = this.count.indexOf(name);
      this.count.splice(index, 1);
    },
    convertData(data, type, enums) {
      let result = data;
      console.log(data);

      if ("Time" == type) {
        result = global.dateFtt("yyyy-MM-dd hh:mm:ss", new Date(data * 1000));
      } else if ("Enum" == type) {
        result = enums[data] == undefined ? data : enums[data];
      }

      console.log(result);
      return result;
    },
    // 点击事件：点击显示数据集
    showData(row, index) {
      // 遍历数据集拼接HTML
      var htmlStr = "";
      var _this = this;

      let mainType = row.messageMaintype;
      let subType = row.messageSubtype;
      console.log(_this.valveProfile);

      try {
        htmlStr =
          "<table style='border:1px solid #C0C0C0; text-align: center;width: 100%; table-layout:fixed;'>";
        var amount = 0;
        let dataObject = JSON.parse(row.messageContent);
        var data;
        data = dataObject;
        Object.keys(data).forEach(function(key) {
          if (amount % 2 == 0) {
            htmlStr += "<tr >";
          }
          htmlStr +=
            "<td style='margin-top:2px; border: 1px solid #C0C0C0;word-wrap:break-word;'>" +
            (_this.valveProfile[mainType] == undefined ||
            _this.valveProfile[mainType][subType] == undefined ||
            _this.valveProfile[mainType][subType]["params"][key] == null
              ? key
              : _this.valveProfile[mainType][subType]["params"][key].cn) +
            "</td><td style='margin-top:2px; border: 1px solid #C0C0C0;word-wrap:break-word;'>" +
            _this.convertData(
              data[key],
              _this.valveProfile[mainType][subType]["params"][key] == undefined
                ? ""
                : _this.valveProfile[mainType][subType]["params"][key].type,
              _this.valveProfile[mainType][subType]["params"][key] == undefined
                ? ""
                : _this.valveProfile[mainType][subType]["params"][key].enum
            ) +
            (_this.valveProfile[mainType] == undefined ||
            _this.valveProfile[mainType][subType] == undefined
              ? ""
              : " " +
                (_this.valveProfile[mainType][subType]["params"][key] ==
                undefined
                  ? ""
                  : _this.valveProfile[mainType][subType]["params"][key]
                      .unit)) +
            "</td>";
          if (amount % 2 == 1) {
            htmlStr += "</tr>";
          }
          amount++;
        });

        htmlStr += "</table>";
        _this.selectDataHtml = htmlStr;
        _this.selectData = data;
      } catch (err) {
        console.log(err);
        _this.selectDataHtml = "<div>JSON格式错误</div>";
        _this.selectData = row.messageContent;
        htmlStr = _this.selectDataHtml;
      }
      // this.showDrawer = true;

      var that = this;
      this.$Notice.open({
        title: "存储编号:" + row.messageId + "\t设备编号:" + row.messageMac,
        // desc: htmlStr,
        render: h => {
          return h("div", {
            on: {},
            style: {
              height: "100%",
              width: "100%"
            },
            domProps: {
              innerHTML: htmlStr
            }
          });
        },
        duration: 20
      });
    }
  },
  data() {
    let that = this;
    return {
      valveProfile: {},
      valveDownProfile: {},
      columns1: [
      {
          title: "姓名",
          key: "",
          align: "center",
          render: function(h, params) {
            return h(
              "div",
              params.row.name  == "null" ? "" : params.row.name
            );
          }
        },
        {
          title: "电话",
          key: "",
          align: "center",
          render: function(h, params) {
            return h(
              "div",
              params.row.phone  == "null" ? "" : params.row.phone
            );
          }
        },
        {
          title: "地址",
          key: "",
          align: "center",
          render: function(h, params) {
            return h(
              "div",
              params.row.address  == "null" ? "" : params.row.address
            );
          }
        },
        {
          title: "设备编号",
          key: "",
          align: "center",
          render: function(h, params) {
            return h(
              "div",
              params.row.valveBaseNumber 
            );
          }
        },
        {
          title: "设备MAC",
          key: "",
          align: "center",
                    render: function(h, params) {
            return h(
              "div",
              params.row.valveBaseMac 
            );
          }
        },
        {
          title: "操作",
          sortable: true,
          slot: "deparams",
          align: "center"
        }
	  ],
      reloadMessage: {},
      data1: [],
      loading: true,
      showDrawer: false,
      selectDataHtml: "",
      selectData: {},
      modal8: false,
      pageTotal: 0,
      pageSize: 30,
      selectedCondition: [],
      commandEnum: global.valveMessageTypeEnum2,
      saveIdModel: "",
      deviceIdModel: "",
      mainTypeModel: "",
      subTypeModel: "",
      commandIdModel: "",
      timeStampModel: "",
      pageNo: 1,
      requestBody: {},
      showDown: false,
      currentDownStep: 0,
      valvesNo: [],
      selectedValve: "",
      selectValveArray: [],
      paramSet: {},
      selectedDownValve: "",
      showBindCheck: false,
      bindArray: [],
      gId: "",
      importUrl: "/api/mp/importValveTemplate?gId=",
      showSetModal: false,
      overdue: 3,
      steal: 7,
      poverdue: 7,
      collection: 10,
      isAdmin: false
    };
  }
};
</script>

<style>
.ivu-notice-notice {
  width: 500px;
  right: 160px;
}
.query_condition {
  border: 1px solid #c0c0c0;
  padding: 2px;
  margin: 2px;
  border-radius: 5%;
}
.check_grop div {
  margin-bottom: 1px;
}
</style>